import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { EleveCompetences } from '../../../../../views/EspaceProf/tabs/CompetencesTab';
import { Competence } from '../../../../../types/note/note.def';

interface TableDateLineCompetencesProps {
  eleveCompetences: EleveCompetences;
}

export const TableDateLineCompetences = ({
  eleveCompetences
}: TableDateLineCompetencesProps) => {
  return (
    <>
      <tr>
        <TableDataCase
          variant="data"
          data={eleveCompetences.lastname + ' ' + eleveCompetences.firstname}
        />
        {eleveCompetences &&
          eleveCompetences.competences.map((competence: Competence, i) => (
            <TableDataCase
              variant="data"
              data={competence.niveau + ' / 4'}
              key={i}
            />
          ))}
      </tr>
    </>
  );
};
